module.exports = __webpack_public_path__ + "static/media/President_Megawati_Sukarnoputri_-_Indonesia_compressed.7974900d.jpg";